import { useContext } from "react";
import FormContext from "../../context/FormContext.js";
import Container from "../../components/FormContainer/FormContainer.js";
import Row from "../../components/RowField/RowField.js";
import Section from "../../components/FormSection/FormSection.js";
import Input from "../../components/InputField/InputField.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import StaticDataContext from "../../context/StaticDataContext.js";
import { createList } from "../../utils/utils.js";

export default function EmergencyContact() {
    const { formData } = useContext(FormContext);
    const { injectFormProps } = useInjectFormProps();
    const { staticData } = useContext(StaticDataContext);


    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"Emergency Contacts & Medical Information"}>
                        <Input type="noyesradio" inputLabel={"Other than Guardian, does the student have another emergency contact?"} identifier={"hasEmergencyContact"} />
                        {formData["hasEmergencyContact"] === "1" &&
                            <>
                                <Input type="text" inputLabel={<>{"Emergency Contact Name"} <i>(Other than Guardian)</i></>} identifier={"emergencyContName"} />
                                <Row>
                                    <Input type="select" inputLabel={"Relationship to Student"} identifier={"emergencyContRelationship"} options={createList(staticData, "personRelation")} />
                                    <Input type="phone" inputLabel={"Home Phone Number"} identifier={"emergencyContHomePhone"} mandatory={false} />
                                    <Input type="phone" inputLabel={"Cell Phone Number"} identifier={"emergencyContCellPhone"} mandatory={false} />
                                </Row>
                            </>
                        }
                        <hr />
                        <Input type="noyesradio" inputLabel={"Do you have a childcare provider?"} identifier={"hasChildcareProvider"} />
                        {formData["hasChildcareProvider"] === "1" &&
                            <Row>
                                <Input type="text" inputLabel={"Name of Childcare Provider"} identifier={"childcareName"} />
                                <Input type="phone" inputLabel={"Home Phone Number"} identifier={"childcareHomePhone"} mandatory={false} />
                                <Input type="phone" inputLabel={"Cell Phone Number"} identifier={"childcareCellPhone"} mandatory={false} />
                            </Row>
                        }
                        <hr />
                        <Input type="noyesradio" inputLabel={"Does your child have any special needs, medical restrictions, or severe/life-threatening medical conditions that the school should be aware of? (e.g., allergies, asthma, epilepsy, etc.)"} identifier={"hasMedicalCondition"} />
                        {formData["hasMedicalCondition"] === "1" &&
                            <Input type="text" inputLabel={"Please provide details or comments below regarding your child that would be helpful to the school"} identifier={"medicalNote"} />
                        }
                    </Section>
                    {formData["isBusRequired"] === "1" &&
                        <>
                            <hr />
                            <Section title={"Billet Information"}>
                                <p>
                                    <b>For rural bus students:</b> in case the buses do not run due to bad weather conditions, bus failure or an emergency, we require a billet home in town for your child. Please contact the school if you can't provide the information below.
                                </p>
                                <Input type="text" inputLabel={"Billet Name"} identifier={"billetName"} mandatory={false} />
                                <Row>
                                    <Input type="phone" inputLabel={"Home Phone Number"} identifier={"billetHomePhone"} mandatory={false} />
                                    <Input type="phone" inputLabel={"Work and/or Cell Phone Number"} identifier={"billetCellPhone"} mandatory={false} />
                                </Row>
                            </Section>
                        </>
                    }
                </>)}
        </Container>
    )
}